// Purpose: Defines the list of CLI (licensing) plans and their max user count.
// This is used to determine whether the user is allowed to use the CLI given current number
// of seats in monday.com.

interface MaxUserCountMapping {
  [plan_id: string]: number;
}

export const plans: MaxUserCountMapping = {
  plan_ver_a_2_users: 2,
  plan_ver_a_3_users: 3,
  plan_ver_a_5_users: 5,
  plan_ver_a_10_users: 10,
  plan_ver_a_15_users: 15,
  plan_ver_a_20_users: 20,
  plan_ver_a_25_users: 25,
  plan_ver_a_30_users: 30,
  plan_ver_a_40_users: 40,
  plan_ver_a_50_users: 50,
  plan_ver_a_100_users: 100,
  plan_ver_a_200_users: 200,
  plan_ver_a_300_users: 300,
  plan_ver_a_400_users: 400,
  plan_ver_a_500_users: 500,
  plan_ver_a_1000_users: 1000,
  plan_ver_a_2000_users: 2000,
  plan_ver_a_5000_users: 5000,
  plan_ver_a_unlimited_users: 999999,
};
